import React, { useState } from "react";
import "./NavBar.css";
import searchPngImg from "../images/search.png";
import addItemPng from "../images/add.png";
import { useDispatch, useSelector } from "react-redux";
import { rxDB } from "../redux";
import backPngIcon from "../images/back.png";
import cancelPngIcon from "../images/cancel.png";
import { Link } from "react-router-dom";

const NavBar = () => {
  const dispatch = useDispatch();

  const switchNav = useSelector((state) => state.switchNav);

  const [query, setQuery] = useState("");

  const queryHandler = (e) => {
    setQuery(e.target.value);
    dispatch(rxDB.searchStringHandler(e.target.value));
  };

  const switchNavHandler = () => {
    dispatch(rxDB.flipNav());
  };

  return (
    <div className="nav__Bar">
      {!switchNav && (
        <div className="nav__BarOne">
          <div className="nav__one__container">
            <img className="nav__searchIcon" src={searchPngImg} alt="search" />
            <input
              value={query}
              onChange={(e) => queryHandler(e)}
              className="nav__searchInputBox"
              type="text"
              placeholder="Search for expenses"
            />
          </div>
          <Link to="add" style={{ textDecoration: "none" }}>
            <div className="nav__addItem" onClick={switchNavHandler}>
              <img src={addItemPng} alt="add" className="addItemPng" />
              <p className="nav__addItemAdd">Add</p>
            </div>
          </Link>
        </div>
      )}
      {switchNav && (
        <div className="nav__BarTwo">
          <div className="nav__two__container">
            <Link to="/" style={{ textDecoration: "none", color: "black" }}>
              <div className="left__twoBox" onClick={switchNavHandler}>
                <img
                  src={backPngIcon}
                  alt="backButton"
                  className="back__btnTwo"
                />
                <p className="twoLeftBackTitle">Back</p>
              </div>
            </Link>

            <Link to="/" style={{ textDecoration: "none", color: "black" }}>
              <div className="right__twoBox" onClick={switchNavHandler}>
                <img
                  src={cancelPngIcon}
                  alt="cancel"
                  className="cancelRightTwo"
                />
                <p className="twoRightCancelTitle">Cancel</p>
              </div>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavBar;
